import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal, PopupModal } from "../Components";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import { MarketingNavbarComponent } from "../Components/navbar/marketingnav";
import { BiSearch } from "react-icons/bi";
import axiosConfig from "../Service/axiosConfig"
import { FormParser } from "../Components";
import Modal from 'react-bootstrap/Modal';
import Masters from "../Components/masters.json";
import DataTable from 'react-data-table-component';
import { MdDeleteOutline, MdOutlineEdit, MdOutlineRemoveRedEye } from "react-icons/md";
import useDebouncedValue from "../Utils/Debounce";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
const CustomerManagement = () => {
    const MastersModal = Masters.CustomerManagement
    const [search, SetSearch] = useState({
        search: ""
    })
    const debouncedSearchTerm = useDebouncedValue(search.search, 500);
    const HandleSearch = (e) => {
        e.preventDefault()
        const name = e.target.name
        const value = e.target.value
        console.log(name, value)
        SetSearch({ ...search, [name]: value })
    }
    const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
    const [Error, SetError] = useState("")
    const [deletePopupType, setDeletepopupType] = useState("");
    const [Data, SetData] = useState([]);
    const [loading, setLoading] = useState(false)
    const [RowId, SetRowId] = useState()
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [RowPerPage, setRowPerPage] = useState(20);
    const [popupType, setpopupType] = useState("")
    const [show, setShow] = useState(false);
    const [modalTitle, setModalTitle] = useState("Create User List");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [formData, setFormData] = useState({
        full_name: '',
        email: '',
        mobileno: '',
        // role: "customer"
    });
    const handleShow = () => {
        setShow(true)
        // setSelectedImage("")
        setFormData({
            full_name: '',
            email: '',
            mobileno: ''
        });
        setCustomerid(null);
        setModalTitle("Create Customer");
    };
    const handleClose = () => {
        setShow(false)
        // SetError("")
        setpopupType("")
    };
    const handleSort = (column, direction) => {
        console.log(column.selector, direction)
        axiosConfig.get(`/user_data/user_list/?page=${currentPage}&page_size=${RowPerPage}&ordering=${direction === "asc" ? column.selector : -column.selector}`).then(res => {
            SetData(res.data.results)
        }).catch(error => {
            console.log(error)
        })
        setCurrentPage(1);
    };
    const formSubmit = (FormData) => {
        console.log(FormData)
        axiosConfig.defaults.headers['Content-Type'] = 'multipart/form-data';
        if (FormData.id) {
            axiosConfig.patch(`/user_data/user_list/${FormData.id}/`, FormData)
                .then(res => {
                    console.log(res)
                    setpopupType("success")
                    GetData();
                    setShow(false);
                }).catch(error => {
                    console.log(error)
                    setpopupType("error")
                })
        } else {
            axiosConfig.post("/user_data/user_list/", FormData).then(res => {
                console.log(res)
                setpopupType("success")
                GetData();
                setShow(false);
            }).catch(error => {
                console.log(error)
                setpopupType(error)
            })
        }
    };
    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === "startDate") setStartDate(value);
        if (name === "endDate") setEndDate(value);
    };
    // const GetData = async () => {
    //     setLoading(true)
    //     try {
    //         const responce = await axiosConfig.get(`/user_data/user_list/?page=${currentPage}&page_size=${RowPerPage}`)
    //         console.log(responce)
    //         SetData(responce.data.results)
    //         setLoading(false)
    //         setTotalRows(responce.data.count)
    //     }
    //     catch (error) {
    //         console.log(error)
    //     }

    // }
    const GetData = async () => {
        setLoading(true);
        try {
            let url = `/user_data/user_list/?page=${currentPage}&page_size=${RowPerPage}`;

            // Add date filtering if both dates are selected
            if (startDate && endDate) {
                url += `&start_date=${startDate}&end_date=${endDate}`;
            }

            const response = await axiosConfig.get(url);
            console.log(response);
            SetData(response.data.results);
            setLoading(false);
            setTotalRows(response.data.count);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const getSearchResults = async () => {
            axiosConfig.get(`/user_data/user_list/?search=${debouncedSearchTerm}`).then(res => {
                SetData(res.data.results)
            }).catch(error => {
                console.log(error)
            })
        };
        getSearchResults();
    }, [debouncedSearchTerm]);
    useEffect(() => {
        GetData();
    }, [startDate, endDate]);


    const [customerid, setCustomerid] = useState()
    const Customeredit = (id) => {
        console.log(id, 'iddddd')
        axiosConfig.get(`/user_data/user_list/${id}/`).then(res => {
            console.log(res.data)
            setFormData(res.data)
            setCustomerid(id)
            setShow(true)
        }).catch(error => {
            console.log(error)
        })
    }
    // const tableCustomStyles = {
    //     rows: {
    //         style: {
    //         },
    //     },
    //     cells: {
    //         style: {
    //             justifyContent: "center",
    //             // width :"200px"
    //         },
    //     },
    //     headCells: {
    //         style: {
    //             color: "#5C5C5C",
    //             justifyContent: "center",
    //             color: "rgb(33,37,41)",
    //             fontSize: "12px",
    //             fontWeight: 500,
    //             lineHeight: "28px",
    //         },
    //     },
    // };
    const columns = [
        {
            name: "S.No",
            selector: "id",
            cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
            sortable: true,
            reorder: true,
        },
        {
            name: "Full Name",
            selector: "name",
            // cell: row => row.full_name,
            sortable: true,
            reorder: true,
        },
        {
            name: "Email",
            selector: "email",
            // cell: row => row.email,
            sortable: true,
            reorder: true,
        },
        {
            name: "Mobile no.",
            selector: "mobile_no",
            // cell: row => row.mobileno,
            sortable: true,
            reorder: true,
        },
        {
            name: "Store Name",
            selector: "store",
            // cell: row => row.mobileno,
            sortable: true,
            reorder: true,
        },
        {
            name: "Last purchased Date",
            selector: "last_purchased_date",
            // cell: row => row.mobileno,
            sortable: true,
            reorder: true,
        },
        {
            name: "Average Cart Value(Rs)",
            selector: "avg_cart_value",
            sortable: true,
            reorder: true,
        },
        {
            name: "Common Category",
            selector: "common_category",
            sortable: true,
            reorder: true,
        },
        {
            name: "Common Items",
            selector: "common_items",
            sortable: true,
            reorder: true,
        },
        {
            name: "Order Frequency",
            selector: "order_frequency",
            sortable: true,
            reorder: true,
        },
        {
            name: "Registered Date",
            selector: "registered_date",
            sortable: true,
            reorder: true,
        },
        {
            name: "ACTIONS",
            reorder: true,
            selector: row => {
                const HandleEdit = async () => {
                    console.log(row.id, 'iddddd')
                    setShow(true)
                    Customeredit(row.id)
                    handleShow(row.id);
                    setModalTitle("Edit Customer");
                }
                const DeleteAlert = () => {
                    SetRowId(row.id)
                    SetAlertDeletePopupType("success")
                }
                const CancelAlerrt = () => {
                    SetAlertDeletePopupType("error")
                }
                // const HandleDelete = async (id) => {
                //     await axiosConfig.delete(`/accounts/users/${id}/`).then(() => {
                //         SetAlertDeletePopupType("error")
                //         setDeletepopupType("success")
                //         GetData();
                //     }).catch((error) => {
                //         setDeletepopupType("error")
                //         SetAlertDeletePopupType("error")
                //         console.log(error)
                //     })
                // }
                return (
                    <>
                        <div className="row" >
                            <div className="table-actions">
                                <button className="action-btn edit-btn" onClick={HandleEdit}>
                                    <MdOutlineRemoveRedEye />
                                </button>

                                <button className="action-btn delete-btn" onClick={HandleEdit}>
                                    <MdOutlineEdit className="dashboard-tabe-data-actions"  /> Edit
                                </button>
                            </div>
                            <div className="col-4">
                            </div>
                            <div className="col-4">

                            </div>
                            {/* <div className="col-4">
                                <MdDeleteOutline className="dashboard-tabe-data-actions" onClick={DeleteAlert} />
                            </div> */}
                        </div>
                        {
                            AlertDeletePopupType === "success" &&
                            <AlertDeletePopupModal AlertDeletePopupType={AlertDeletePopupType} CancelAlerrt={CancelAlerrt} row={RowId} />
                        }
                    </>
                )

            }
        }
    ]

    return (
        <>
            <div className="child-sidenav">
                <MarketingNavbarComponent />
                <div className="childnav-content">
                    <div className="d-flex align-items-center">
                        <div className="input-cat-with-icon">
                            <span className="icon-product">
                                <BiSearch />
                            </span>
                            <input
                                type="text"
                                className="input-control"
                                placeholder="Search"
                                name="search"
                                value={search.search}
                                onChange={HandleSearch}
                            />
                        </div>
                        <div className="cat-button">
                            <div className="btn" onClick={handleShow}>
                                + Add New
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <div className="form-group">
                            <input className="form-control" type="date" name="startDate" value={startDate} onChange={handleDateChange} />

                        </div>
                        <div className="form-group ms-1">
                            <input className="form-control" type="date" name="endDate" value={endDate} onChange={handleDateChange} />

                        </div>
                    </div>
                    <div className="table-responsive marginTop">
                        <DataTable columns={columns} data={Data} pagination paginationTotalRows={totalRows}
                            paginationPerPage={RowPerPage}
                            paginationDefaultPage={currentPage}
                            onChangePage={(page) => setCurrentPage(page)}
                            paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                            paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                            onChangeRowsPerPage={(RowsPerPageChange) => setRowPerPage(RowsPerPageChange)}
                            onSort={handleSort}
                            paginationServer fixedHeader subHeader customStyles={tableCustomStyles} progressPending={loading}
                            progressComponent={<div className="loader-container">
                                <img src={require('../Components/FormParser/images/loader2.gif')} alt="Loading..." />
                            </div>}
                        />
                    </div>
                    <div>
                        <Modal
                            size="xl"
                            show={show}
                            onHide={handleClose}
                            aria-labelledby="example-modal-sizes-title-lg"
                        >
                            <Modal.Header closeButton>
                                <Modal.Title id="example-modal-sizes-title-lg">
                                    {modalTitle}
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <FormParser modelObject={MastersModal} formData={formData} formSubmit={formSubmit} error={Error} buttonTitle='Save' />
                            </Modal.Body>
                        </Modal>
                        {popupType !== "" &&
                            <PopupModal setpopupType={setpopupType} popupType={popupType} Navigation="" />
                        }
                        {deletePopupType !== "" &&
                            <DeletePopupModal setDeletepopupType={setDeletepopupType} deletePopupType={deletePopupType} />
                        }
                    </div>

                </div>
            </div>
        </>
    )
}
export { CustomerManagement }